import type {IInputProps} from "../../FieldInput";
import {DateTimeInput} from "../../../datetime/DateTimeInput";
import type {IDateFieldSettingsDefinition} from "../../../../../modules/settings/modules/field/datatypes/DateFieldSettings";

export const DateInput = (props: IInputProps<IDateFieldSettingsDefinition>) => {
	const {value, onClick, onChange, dataTypeSettings, disabled, inline, focused, onInput} = props;

	return (
		<DateTimeInput
			value={value}
			format={dataTypeSettings.format}
			disabled={disabled}
			focused={focused}
			onInput={onInput}
			onChange={onChange}
			onClick={onClick}
			inline={inline}
		/>
	);
};
